<template>
  <svg width="10" height="13" viewBox="0 0 10 13" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path :fill="color" d="M0 11h10v2H0z"/><path :stroke="color" d="M.5 11.5h9v1h-9z"/><path class="dlb__arrow" d="M4.506 9.385l.322.094.323-.094 3.799-3.8-.707-.706-2.914 2.915V.5h-1v7.294L1.414 4.879l-.707.707 3.799 3.799z" :stroke="color" :fill="color"/></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#363a5e'
    }
  }
}
</script>
